import { Protocol } from '@studio/models/audio';

/** Language constants. */
export const Lang = Object.freeze({
  protocol: {
    [Protocol.Local]: 'Local',
    [Protocol.Network]: 'Network'
  } satisfies Record<Protocol, string>
});

/** @internal */
export const PrefKeys = Object.freeze({
  muted: 'audio.main.muted',
  volume: 'audio.main.volume'
});
